export interface DailyRecord {
  id: string;
  date: string;
  farm: string;
  house: string;
  flockId: string;
  flockNumber: string;
  flockName: string;
  openingCount: number;
  mortality: number;
  culled: number;
  closingCount: number;
  feedIssued: number;
  feedConsumed: number;
  waterIssued: number;
  waterConsumed: number;
  eggsProduced: number;
  avgTemperature: number;
  humidity: number;
  observations: string;
  recordedBy: string;
  status: 'draft' | 'submitted' | 'approved';
  createdAt: string;
}

export const FARMS = ['Idudi Poultry Farm', 'Kampala Demo Farm'];

export const HOUSES_BY_FARM: Record<string, string[]> = {
  'Idudi Poultry Farm': ['House A1', 'House A2', 'House B1', 'Layer House 01', 'Layer House 02', 'Breeder House 01', 'Free Range Area'],
  'Kampala Demo Farm': ['House C1', 'House D2', 'Layer House 03'],
};

export interface FlockOption {
  id: string;
  flockNumber: string;
  flockName: string;
  farm: string;
  house: string;
  currentQty: number;
  birdType: string;
}

export const FLOCK_OPTIONS: FlockOption[] = [
  { id: 'flock-002', flockNumber: 'BR-2026-002', flockName: 'Batch A2 — Ross 308', farm: 'Idudi Poultry Farm', house: 'House A2', currentQty: 4614, birdType: 'Broiler' },
  { id: 'flock-003', flockNumber: 'BR-2026-003', flockName: 'Batch B1 — Cobb 500', farm: 'Idudi Poultry Farm', house: 'House B1', currentQty: 3432, birdType: 'Broiler' },
  { id: 'flock-004', flockNumber: 'LY-2026-001', flockName: 'Layers Batch L1 — Lohmann', farm: 'Idudi Poultry Farm', house: 'Layer House 01', currentQty: 7742, birdType: 'Layer' },
  { id: 'flock-005', flockNumber: 'LY-2026-002', flockName: 'Layers Batch L2 — Isa Brown', farm: 'Idudi Poultry Farm', house: 'Layer House 02', currentQty: 6318, birdType: 'Layer' },
  { id: 'flock-006', flockNumber: 'LY-2026-003', flockName: 'Layers Batch L3 — Lohmann', farm: 'Kampala Demo Farm', house: 'Layer House 03', currentQty: 3940, birdType: 'Layer' },
  { id: 'flock-007', flockNumber: 'BRD-2026-001', flockName: 'Breeders Flock BD1 — Ross', farm: 'Idudi Poultry Farm', house: 'Breeder House 01', currentQty: 2358, birdType: 'Breeder' },
  { id: 'flock-008', flockNumber: 'BR-2026-004', flockName: 'Batch C1 — Arbor Acres', farm: 'Kampala Demo Farm', house: 'House C1', currentQty: 5974, birdType: 'Broiler' },
  { id: 'flock-009', flockNumber: 'LOCAL-2026-001', flockName: 'Local Kienyeji Batch 01', farm: 'Idudi Poultry Farm', house: 'Free Range Area', currentQty: 762, birdType: 'Local/Indigenous' },
];

// Backend: GET /api/daily-records
export const MOCK_DAILY_RECORDS: DailyRecord[] = [
  {
    id: 'dr-001',
    date: '2026-09-04',
    farm: 'Idudi Poultry Farm',
    house: 'House A2',
    flockId: 'flock-002',
    flockNumber: 'BR-2026-002',
    flockName: 'Batch A2 — Ross 308',
    openingCount: 4614,
    mortality: 3,
    culled: 1,
    closingCount: 4610,
    feedIssued: 920,
    feedConsumed: 905,
    waterIssued: 1840,
    waterConsumed: 1820,
    eggsProduced: 0,
    avgTemperature: 28.4,
    humidity: 68,
    observations: 'Normal activity. Slight increase in water consumption noted. No signs of disease.',
    recordedBy: 'James Okello',
    status: 'approved',
    createdAt: '2026-09-04T07:30:00Z',
  },
  {
    id: 'dr-002',
    date: '2026-09-04',
    farm: 'Idudi Poultry Farm',
    house: 'Layer House 01',
    flockId: 'flock-004',
    flockNumber: 'LY-2026-001',
    flockName: 'Layers Batch L1 — Lohmann',
    openingCount: 7742,
    mortality: 2,
    culled: 0,
    closingCount: 7740,
    feedIssued: 1548,
    feedConsumed: 1540,
    waterIssued: 3100,
    waterConsumed: 3080,
    eggsProduced: 7120,
    avgTemperature: 26.8,
    humidity: 72,
    observations: 'Good production day. Egg production at 92%. Feed intake normal.',
    recordedBy: 'Sarah Namukasa',
    status: 'submitted',
    createdAt: '2026-09-04T08:15:00Z',
  },
  {
    id: 'dr-003',
    date: '2026-09-03',
    farm: 'Idudi Poultry Farm',
    house: 'House B1',
    flockId: 'flock-003',
    flockNumber: 'BR-2026-003',
    flockName: 'Batch B1 — Cobb 500',
    openingCount: 3435,
    mortality: 3,
    culled: 0,
    closingCount: 3432,
    feedIssued: 686,
    feedConsumed: 680,
    waterIssued: 1372,
    waterConsumed: 1360,
    eggsProduced: 0,
    avgTemperature: 29.1,
    humidity: 65,
    observations: 'Slightly elevated temperature in afternoon. Ventilation adjusted.',
    recordedBy: 'James Okello',
    status: 'approved',
    createdAt: '2026-09-03T07:45:00Z',
  },
  {
    id: 'dr-004',
    date: '2026-09-03',
    farm: 'Kampala Demo Farm',
    house: 'House C1',
    flockId: 'flock-008',
    flockNumber: 'BR-2026-004',
    flockName: 'Batch C1 — Arbor Acres',
    openingCount: 5976,
    mortality: 2,
    culled: 0,
    closingCount: 5974,
    feedIssued: 1195,
    feedConsumed: 1188,
    waterIssued: 2390,
    waterConsumed: 2370,
    eggsProduced: 0,
    avgTemperature: 27.5,
    humidity: 70,
    observations: 'All birds active and healthy. Feed consumption on target.',
    recordedBy: 'Peter Mugisha',
    status: 'approved',
    createdAt: '2026-09-03T08:00:00Z',
  },
];
